/**
 * Demo Roles Configuration
 *
 * This file contains the static list of demo roles that are available for demo logins.
 * These are bundled with the web app, so they load instantly without requiring
 * the backend API to be available. This is critical for production environments where
 * the backend may not always be running.
 */

import type { DemoRole } from '../../../shared/contracts';

export const DEMO_ROLES: DemoRole[] = [
  {
    id: "company_owner",
    name: "Company Owner",
    description: "Manage company settings, branches, and users",
  },
  {
    id: "manager",
    name: "Manager",
    description: "Oversee operations and manage service requests",
  },
  {
    id: "technician",
    name: "Technician",
    description: "Handle service requests and update status",
  },
  {
    id: "operator",
    name: "Operator",
    description: "Create and monitor service requests",
  },
];
